import actions from '../actions/lodgingCancellationPolicyActions';

import createReducer from '../utils/createReducer';

// see graphql-lodging-policy type LodgingCancellationPolicy
export const initialState = {
    cancellationPolicyLabel: {
        label: '',
        isFullRefundWindow: false
    },
    undatedPolicyText: '',
    cancellationPolicyPeriods: [],
    cancellationTimelinePeriods: [],
    nonRefundableFeeLabel: null
};

const actionHandlers = {
    [actions.UPDATE_LODGING_CANCELLATION_POLICY](_, {payload = {}}) {
        const {lodgingCancellationPolicy} = payload;
        return {...initialState, ...lodgingCancellationPolicy};
    }
};

export default createReducer(actionHandlers, initialState);
